import PropTypes from 'prop-types';
// material
import { Card, CardHeader, Box, Typography } from '@mui/material';

// ----------------------------------------------------------------------

Label.propTypes = {
  title: PropTypes.string
};

export function Label({ title }) {
  return (
    <Typography variant="overline" component="p" gutterBottom sx={{ color: 'text.secondary' }}>
      {title}
    </Typography>
  );
}

Block.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  sx: PropTypes.object
};

export function Block({ title, sx, children }) {
  return (
    <Card
      sx={{
        overflow: 'unset',
        position: 'unset',
        width: '100%',
        borderRadius: '4px',
        boxShadow: '0px 4px 12px rgba(36, 137, 188, 0.1)'
      }}
    >
      {title && <CardHeader title={title} />}
      <Box
        sx={{
          p: 0.5,
          mt: 2,
          minHeight: 40,
          ...sx
        }}
      >
        {children}
      </Box>
    </Card>
  );
}
